<form class="example-form">
	<mat-form-field class="example-full-width">
	  <mat-label>{{devLabel}}</mat-label>
	  <input matInput [ngStyle]="{'color': theme === 'light' ? '#27304c' : 'white'}" (input)="searchThis()" [(ngModel)]="searchword" name="searchword">
	</mat-form-field>


  </form>
